<template>
<v-select box v-model="operator" :items="allOperators" :hide-details="hideDetails" :label="$t('reactor.select_operator')"></v-select>
</template>

<script>
export default {
  name: 'OperatorSelector',
  props: {
    value: {
      type: String
    },
    'hideDetails': {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      allOperators: [{
        text: '>',
        value: '>'
      }, {
        text: '>=',
        value: '>='
      }, {
        text: '=',
        value: '='
      }, {
        text: '<=',
        value: '<='
      }, {
        text: '<',
        value: '<'
      }, {
        text: '≠',
        value: '!='
      }]
    }
  },
  computed: {
    operator: {
      get() {
        return this.value;
      },
      set(val) {
        return this.$emit('input', val);
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reactor/OperatorSelector.vue